import Plyr from 'plyr';

export default function (el) {
  if (el === null) return false;

  const player = new Plyr(el, {
    ratio: '16:9',
  });
}
